import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User inserted a CDN link block into their CMS',
  name: 'insert_cdn_link_block',
  params: [
    {
      description: 'Whether the user is inserting a new asset or replacing an existing one',
      name: 'action',
      required: true,
      type: 'enum',
      values: ['insert', 'replace'],
    },
    {
      description: 'The Air asset ID',
      name: 'asset_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The type of CDN link used (imgix for static, original for dynamic/air CDN)',
      name: 'cdn_type',
      required: true,
      type: 'enum',
      values: ['imgix', 'original'],
    },
    {
      description: 'The height of the inserted asset in pixels',
      name: 'height',
      required: true,
      type: 'number',
    },
    {
      description: 'The width of the inserted asset in pixels',
      name: 'width',
      required: true,
      type: 'number',
    },
    {
      description: 'The version of the asset (e.g. "latest")',
      name: 'version',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
